module.exports = __webpack_public_path__ + "img/super_olimpico.feb8150c.png";